import React from "react";
import { Card, Box, Avatar, Typography, CardMedia } from "@mui/material";
import AppNavigation from "../navigation/AppNavigation";

const Card130LifeStyleCard = ({ card }) => {
  const cardData = card.cardData[0]?.data || {}; // Safely access card data

  const { handleNavigation } = AppNavigation();

  const handleProfileClick = () => {
    const onTap = card.cardData[0]?.data?.userImageOnTap;
    console.log("onTap", onTap);

    if (onTap) {
      const onTapNavigationType = {
        ...onTap,
        NavigationType: "3",
      };

      console.log("Menu onTap with NavigationType set to 3:", onTapNavigationType);
      handleNavigation(onTapNavigationType);
    } else {
      console.log("No menu onTap data found.");
    }
  };

  const handleCardClick = () => {
    const onTap = card.cardData[0]?.data?.onTap;
    console.log("onTap", onTap);

    if (onTap) {
      const onTapNavigationType = {
        ...onTap,
        NavigationType: "3",
        FSN: "223",
        FAI: {
          url: "https://lifestyle.goqii.com/lifestyleinsights/a1JYSk91Ry9SYWNoTE8rNjNiUTA5UT09?callingFrom=player",
          title: "GOQii Life",
        },
      };

      console.log("Menu onTap with NavigationType and FAI:", onTapNavigationType);
      handleNavigation(onTapNavigationType);
    } else {
      console.log("No menu onTap data found.");
    }
  };

  return (
    <Card
      onClick={handleCardClick} // Call handleCardClick on full card click
      sx={{
        borderRadius: 2,
        backgroundColor: "#FFF9E3", // Light yellow background
        paddingLeft: 1,
        paddingRight: 1,
        paddingTop: 1,
        paddingBottom: 1,
        boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        position: "relative",
        cursor: "pointer", // Indicate clickable card
      }}
    >
      {/* Left Section */}
      <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
        <Avatar
          src={cardData.userImage}
          alt={cardData.name}
          onClick={handleProfileClick} // Attach click handler here
          sx={{
            width: 70,
            height: 70,
            border: `2px solid ${cardData.profileRingColor || "#4b78c1"}`,
            cursor: "pointer",
          }}
        />
        <Box>
          <Typography
            variant="subtitle2"
            sx={{
              fontWeight: "bold",
              color: "#000",
              lineHeight: 1.2,
              fontSize: "0.9rem",
            }}
          >
            {cardData.name}
          </Typography>
          <Typography
            variant="body2"
            sx={{
              color: "#666",
              fontSize: "0.8rem",
            }}
          >
            GOQii Age:{" "}
            <span
              style={{
                fontWeight: "bold",
                color: cardData.ageTextColor || "#ff0000",
              }}
            >
              {cardData.age}
            </span>
          </Typography>
          <Typography
            variant="caption"
            sx={{
              color: cardData.quoteTextColor || "#ff0000",
              lineHeight: 1.3,
              fontSize: "0.6rem",
            }}
          >
            {cardData.quote}
          </Typography>
        </Box>
      </Box>

      {/* Right Section */}
      <Box
        sx={{
          position: "relative",
          width: 70,
          height: 70,
        }}
      >
        <CardMedia
          component="img"
          src={cardData.lifestyleImage}
          alt="Lifestyle Image"
          sx={{
            width: "100%",
            height: "100%",
            objectFit: "cover",
            borderRadius: 2,
          }}
        />
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            textAlign: "center",
            color: "#fff",
          }}
        >
          <Typography
            variant="h6"
            sx={{
              fontWeight: "bold",
              fontSize: "1rem",
            }}
          >
            {cardData.dayscount}
          </Typography>
          <Typography
            variant="caption"
            sx={{
              fontWeight: "bold",
              fontSize: "0.6rem",
            }}
          >
            {cardData.daysText}
          </Typography>
        </Box>
      </Box>
    </Card>
  );
};

export default Card130LifeStyleCard;